/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100073 得意先納入先マスタ出力
 */
import { Box } from "@mui/material";
import {
  B000150TokuiNm1From,
  B000150TokuiNm1To,
  B100073ExcelRequest,
  B100073GetExcel,
  catchFileError,
} from "clients/rest";
import {
  msgState,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { B000150 } from "pages";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { download } from "services";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiNmFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
  tokuiNmTo: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  tokuiCdFrom: "",
  tokuishitenCdFrom: "",
  tokuiNmFrom: "",
  tokuiCdTo: "",
  tokuishitenCdTo: "",
  tokuiNmTo: "",
};

const focusId = "B100073";

export const B100073 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  }, []);

  // EXCELボタン押下時
  const handleClickExcelButton = () => {
    const fields = methods.getValues();

    const param: B100073ExcelRequest = {
      tokuiCdFrom: fields.tokuiCdFrom!,
      tokuiCdTo: fields.tokuiCdTo!,
      tokuishitenCdFrom: fields.tokuishitenCdFrom!,
      tokuishitenCdTo: fields.tokuishitenCdTo!,
    };

    B100073GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B100073_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="得意先納入先マスタ出力"
        gridTemplateColumns="7rem 6rem 5rem 15rem 1rem 6rem 5rem 15rem 5rem"
      >
        <SText gridColumn="span 9">　</SText>

        <SLabel>得意先コード</SLabel>
        <SNumberField
          name="tokuiCdFrom"
          code
          size={6}
          {...register(1)}
          onBlur={() => B000150TokuiNm1From(methods, navigate, setMsg)}
        />
        <SNumberField
          name="tokuishitenCdFrom"
          code
          size={4}
          {...register(2)}
          onBlur={() => B000150TokuiNm1From(methods, navigate, setMsg)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCdFrom", data.tokuiCd);
            methods.setValue("tokuishitenCdFrom", data.tokuishitenCd);
            methods.setValue("tokuiNmFrom", data.tokuiNm1);
          }}
        />
        <STextField name="tokuiNmFrom" disabled />

        <SText>～</SText>
        <SNumberField
          name="tokuiCdTo"
          code
          size={6}
          {...register(3)}
          onBlur={() => B000150TokuiNm1To(methods, navigate, setMsg)}
        />
        <SNumberField
          name="tokuishitenCdTo"
          code
          size={4}
          {...register(4)}
          onBlur={() => B000150TokuiNm1To(methods, navigate, setMsg)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCdTo", data.tokuiCd);
            methods.setValue("tokuishitenCdTo", data.tokuishitenCd);
            methods.setValue("tokuiNmTo", data.tokuiNm1);
          }}
        />
        <STextField name="tokuiNmTo" disabled />
        <Box />

        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>

        <Box gridColumn="span 7" />
        <SFileButton
          label={labels.buttons.excel}
          align="right"
          {...register(5)}
          dialog={
            <SConfirmDialog
              title="得意先マスタ出力"
              msg={labels.dialog.masterExcelConfirmMessage}
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
